// services/clientService.js
import api from './api';

// Fetch all clients
export const getClients = async () => {
  try {
    const response = await api.get('/clients');
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Server Error');
  }
};

// Fetch a single client by ID
export const getClientById = async (id) => {
  try {
    const response = await api.get(`/clients/id/${id}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Server Error');
  }
};

// Fetch a single client by Slug
export const getClientBySlug = async (slug) => {
  try {
    const response = await api.get(`/clients/slug/${slug}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Server Error');
  }
};

// Create a new client
export const createClient = async (client) => {
  try {
    const response = await api.post('/clients', client, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Server Error');
  }
};

// Update an existing client
export const updateClient = async (id, client) => {
  try {
    const response = await api.put(`/clients/${id}`, client, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Server Error');
  }
};

// Delete a client
export const deleteClient = async (id) => {
  try {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Server Error');
  }
};
